import { render, staticRenderFns } from "./GrantDelete.vue?vue&type=template&id=758c68af&"
import script from "./GrantDelete.vue?vue&type=script&lang=js&"
export * from "./GrantDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports